import { BrowserDocumentServiceInterface } from './service.interface';
import { BrowserDocumentFactory } from '../../module/browser/document.factory';

const windowDocumentService = BrowserDocumentFactory();

export function BrowserDocumentService(): BrowserDocumentServiceInterface {
  return windowDocumentService;
}
